import React, { useState, useEffect } from 'react';
import { Carousel } from '@mantine/carousel';

function OtherServicesCarousel({ activeIndex }) {
  const [activeindex, setActiveIndex] = useState(0);

  const CarouselImages = ["img/index/homeBackground-banner3.jpg"];

  const handleSlideChange = (index) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    setActiveIndex(activeIndex);
  }, [activeIndex]);

  return (
    <Carousel
      height={200}
      slideSize="100%"
      slideIndex={activeindex}
      onSlideChange={handleSlideChange}
      withControls={false}
      withIndicators={false}
      draggable={false}
      loop={false}
      visibleFrom="md"
    >
      {CarouselImages.map((image, index) => (
        <Carousel.Slide key={index}>
          <img
            src={image}
            alt={`Slide ${index}`}
            style={{ objectFit: 'cover', width: "50vw", height: '80vh' }}

          />
        </Carousel.Slide>
      ))}
    </Carousel>
  );
}

export default OtherServicesCarousel;
